import React, { Component } from "react";
import DKLabel from "./common/DKLabel";

class AppDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className="bg-white cursor-hand border-m border-m column width-31 app-card-margin shadow-s border-radius-s"
        style={{ overflow: "hidden" }}
        onClick={() => {
          window.open(this.props.data.url);
        }}
      >
        <img
          src={this.props.data.icon}
          alt=""
          className="parent-width border-s"
        />
        <div className="column p-l">
          <DKLabel text={this.props.data.title} className="fw-b fs-m" />
          <DKLabel
            text={this.props.data.description}
            className="mt-xs text-gray"
          />

          {this.getSkillsRow(this.props.data.skills)}

          {/* <SkillsRow
            className="mt-r"
            skills={[SKILLS.REACT, SKILLS.JAVASCRIPT, SKILLS.HTML, SKILLS.CSS]}
          /> */}

          {/* <DKButton title="Know more" className="mt-m border-ms bg-gray1s" /> */}
        </div>
      </div>
    );
  }

  getSkillsRow(skills) {
    return (
      <div className="row flex-wrap mt-m">
        {skills.map((skill) => {
          return (
            <div className="bg-gray1 p-v-xs p-h-s mr-r mb-s border-radius-m border-s">
              <DKLabel text={skill.title} />
            </div>
          );
        })}
      </div>
    );
  }
}

export default AppDetails;
